import React, { Component } from 'react';
import {
  Button,
  Row,
  Col,
  FormGroup,
  Form,
  ControlLabel,
  FormControl,
  Checkbox,
  Glyphicon
} from 'react-bootstrap';
import Switch from 'react-bootstrap-switch';
import { ToastContainer, ToastStore } from 'react-toasts';
import TimePicker from '../timepicker';
import moment from 'moment';

import './style.css';
import SettingsModal from "../../components/settings-alert";

import UsersService from "../../services/users-service";
import DispatchService from "../../services/dispatches-service";
import _ from 'underscore';

class AddDispatch extends Component{
  constructor(props){
    super(props);

    const editMode = props.itemToEdit ? true : false;
    const data = this.getData();

    const user = UsersService.sharedInstance.getStoredCredentials();

    this.state = {
      license: user.license,
      user_auth: user.username,
      token: user.token,
      loginResponse: user.loginResponse,
      data:data,
      editMode:editMode,
      hasEdit:false,
      dispatch_number: '',

      users:[],
      settings_modal:false
    };

    this._isMounted = false;

    this.onUpdateData = this.onUpdateData.bind(this);
    this.onAddIndividual = this.onAddIndividual.bind(this);
    this.setSettingsModal = this.setSettingsModal.bind(this);
  }

  componentDidMount(){
    this._isMounted = true;

    this.getNewDispatchID();

    this.setState({
      hasEdit: false
    });
  }

  getNewDispatchID = () => {
    DispatchService.sharedInstance.generateDispatchID()
    .then((response)=>{
        // this.onUpdateData('dispatch_number',response);

        const {data} = this.state;
        data['dispatch_number'] = response;

        this.setState({
          data
        });
    })
    .catch((err)=>{
        console.log("fail, error: ", err);
        ToastStore.error( "Could not generate new Dispatch Number.");
    })
  }

  getData = () =>{
    const editMode = this.props.itemToEdit ? true : false;
    const other_form_data = this.props.itemToEdit && this.props.itemToEdit.other_form_data ? JSON.parse(this.props.itemToEdit.other_form_data) : {};

    if(editMode){
      const {
        date_added,
        facility_id,
        call_type_id,
        facility_location_id,
        location_description,
        personnel_data,
        external_agency_data,
        incident_narrative,
        forms_data,
        dispatch_number
      } = this.props.itemToEdit;

      this.props.setSetSettingsModal(this.setSettingsModal.bind(this));

      const {personnel_name,
              personnel_phone,
              personnel_location_id,
              additional_notes,
              external_agency
            } = other_form_data;

      let newData = {
                      date_added: date_added ? moment(date_added) : moment(),
                      facility_id: facility_id ? facility_id : "",
                      call_type_id: call_type_id ? call_type_id : "",
                      facility_location_id: facility_location_id ? facility_location_id : "",
                      location_description: location_description ? location_description : "",
                      personnel_data: personnel_data ? JSON.parse(personnel_data): [{}],
                      personnel_name: personnel_name ? personnel_name : "",
                      personnel_phone: personnel_phone ? personnel_phone : "",
                      personnel_location_id: personnel_location_id ? personnel_location_id : "",
                      additional_notes: additional_notes ? additional_notes : "",
                      external_agency: external_agency,
                      external_agencies: external_agency_data ? JSON.parse(external_agency_data) : {},
                      incident_narrative:  incident_narrative ? incident_narrative : "",
                      forms_data: forms_data ? JSON.parse(forms_data) : [],
                      dispatch_number: dispatch_number,

                      personnel_name: personnel_name ? personnel_name : "",
                      personnel_phone: personnel_phone ? personnel_phone : "",
                      personnel_location_id: personnel_location_id ? personnel_location_id : "",
                      additional_notes: additional_notes ? additional_notes : ""
                    }
      return newData;
    }else{
      return {
        date_added:moment(),
        incident_type_id:'',
        facility_id:'',
        facility_location_id:'',
        auto_email_id:'',
         personnel_data:[{}],
        location_description:'',
        incident_narrative:'',
        external_agency:false,
        external_agencies:{},
        personnel_name:'',
        personnel_phone:'',
        personnel_location_id:'',
        additional_notes:'',
        form_type:'',
        forms_data:[],
        dispatch_number:''
      }
    }
  }

  componentWillUnmount(){
    this._isMounted = false;
  }

  onUpdateData = (key,value) =>{
    const {data} = this.state;

    data[key] = value;

    this.setState({
      data,
      hasEdit:true
    },() => {
      if(this.props.onEdit){
        this.props.onEdit();
      }
    });
  }

  onAddIndividual = () =>{
    const {data} = this.state;
    const { personnel_data} = data;

     personnel_data.push({});

    this.onUpdateData(' personnel_data', personnel_data);
  }

  render(){
    const {settings_modal} = this.state;

    return (
      <React.Fragment>
        <div className='content-div'>
          {this.renderHeader()}
          {this.renderForm()}
        </div>
        <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
        <SettingsModal isShowing={settings_modal} cancelButton={this.onReset} continueButton={this.onCancelReset}/>
      </React.Fragment>
    )
  }

  renderHeader = () =>{
    const {editMode, data} = this.state;
    const {date_added, dispatch_number} = data;
    const dispatch = this.props.itemToEdit ? this.props.itemToEdit.dispatch_number : dispatch_number;
    const title = editMode ? 'Edit Dispatch' : 'Create New Dispatch';
    const date = date_added.format('MMMM DD, YYYY');
    const time = date_added.format('hh:mm A');

    return(
      <div className='incident-header'>
        <div className='incident-title'>
          <h1 className='orange-title left'>{title}</h1>
        </div>
        <div className='incident-dispatch-info'>
          <div className='incident-dispatch-block'>
            <h5 className='incident-card-text'>Dispatch No.</h5>
            {
              //<Button className='incident-edit-button'>Edit</Button>
            }
            <h5 className='dispatch-date-value'>{dispatch}</h5>
          </div>

          <div className='incident-date-block'>
            <h5 className='incident-card-text'>Date</h5>
            {
              //<Button className='incident-edit-button'>Edit</Button>
            }
            <h5 className='dispatch-date-value'>{date}</h5>
            <h5 className='dispatch-date-value'>@ {time}</h5>
          </div>
        </div>
      </div>
    )
  }

  renderForm = () =>{
    return (
      <div id='IncidentCanvasForm' className='add-user-content'>
        <Form className="add-incident-form">
          { this.renderFormSection() }
          { this.renderReportingSection() }
          { this.renderCreateForm() }
          { this.renderFooterSection() }
        </Form>
      </div>
    )
  }

  renderFormSection = () =>{
    const facility_locations = this.props.facility_locations || [];
    const facilities = this.props.facilities || [];
    const call_types = this.props.call_types || [];

    const {data} = this.state;
    const {
      call_type_id,
      facility_location_id,
      facility_id,
      location_description,
      personnel_data,
      incident_narrative
    } = data;
    return (
      <div className='incident-section'>
        <div className='two-header-div'>
            <h3 className='sub-title sub-title-left'>Dispatch Information</h3>
            <h3 className='sub-title sub-title-right'>Dispatched Personnel Details</h3>
        </div>

        <hr className='line' />

        <div className='left-side-content'>

          <FormGroup bsSize='sm'>
            <ControlLabel className='login_label'>Call Type</ControlLabel>
            <FormControl
              componentClass='select'
              placeholder='Select incident type...'
              value={call_type_id}
              onChange={e => this.onUpdateData('call_type_id',e.target.value)}
            >
              <option value=''></option>
              {
                call_types.map((value,key) => {
                  const {recno,Value,is_active} = value;
                  if(is_active == 1){
                      return (
                        <option key={key} value={recno}>{Value}</option>
                      )
                  }
                })
              }
            </FormControl>
          </FormGroup>

          <FormGroup bsSize='sm'>
            <ControlLabel className='login_label'>Facility</ControlLabel>
            <FormControl
              componentClass='select'
              placeholder='Select facility...'
              value={facility_id}
              onChange={e => this.onUpdateData('facility_id',e.target.value)}
            >
              <option value=''></option>
              {
                facilities.map((value,key) => {
                  const {facility_id,facility_name, is_active} = value;
                    if(is_active == 1){
                      return (
                        <option key={key} value={facility_id}>{facility_name}</option>
                      )
                    }
                })
              }
            </FormControl>
          </FormGroup>

          <FormGroup bsSize='sm'>
            <ControlLabel className='login_label'>Location</ControlLabel>
            <FormControl
              componentClass='select'
              placeholder='Select location...'
              value={facility_location_id}
              onChange={e => this.onUpdateData('facility_location_id',e.target.value)}
            >
              <option value=''></option>
              {
                facility_locations.map((value,key) => {
                    const {facility_location_id,location_name, is_active} = value;
                    if(is_active == 1){
                      return (
                        <option key={key} value={facility_location_id}>{location_name}</option>
                      )
                    }
                })
              }
            </FormControl>
          </FormGroup>

          <FormGroup bsSize='sm'>
            <ControlLabel className='login_label'>Detailed Location Description</ControlLabel>
            <FormControl
              rows={4}
              componentClass='textarea'
              placeholder='Location details...'
              value={location_description}
              onChange={(e) => this.onUpdateData('location_description',e.target.value)}
            />
          </FormGroup>

          <FormGroup bsSize='sm'>
            <ControlLabel className='login_label'>Incident Narrative</ControlLabel>
            <FormControl
              rows={4}
              componentClass='textarea'
              placeholder='Narrative from the individual details...'
              value={incident_narrative}
              onChange={(e) => this.onUpdateData('incident_narrative',e.target.value)}
            />
          </FormGroup>
        </div>
        {/* end of left side */}

        <div className='right-side-content'>
          {
             personnel_data.map((value,key) => {
              return this.renderIndividual(value,key)
            })
          }
          <FormGroup>
						<Button className='blue-btn' onClick={this.onAddIndividual}>Add Personnel</Button>
					</FormGroup>
        </div>
        {/* end of right side */}
      </div>
    )
  }

  onUpdateIndividual = (key,name,value) =>{
    const {data} = this.state;
    const { personnel_data} = data;

    if( personnel_data[key]){
       personnel_data[key][name] = value;

       if(name === "user_id") {
         let rawPersonnel = _.find(this.props.users_on_duty, (data)=>{return data.recno === personnel_data[key][name]});


          personnel_data[key]["name"] = rawPersonnel ? rawPersonnel.first_name + " " + rawPersonnel.last_name: "---";
       }

      this.onUpdateData(' personnel_data', personnel_data);
    }
  }

  renderIndividual = (data,key) =>{
    const user_id = data.user_id || '';
    const time_dispatch = data.time_dispatch || null;
    const time_arrived = data.time_arrived || null;
    const guard_status = data.guard_status || '';

    const users_on_duty = this.props.users_on_duty || [];
    return (
      <div className='individual_divider' key={key}>
        <FormGroup controlId={`individual-data-user-${key}`} bsSize='sm'>
          <ControlLabel className='login_label'>Dispatched Personnel</ControlLabel>
          <FormControl
            componentClass='select'
            placeholder='Select personnel...'
            value={user_id}
            onChange={e => this.onUpdateIndividual(key,'user_id',e.target.value)}
          >
            <option value=''>Select Personnel</option>
            {
              users_on_duty.map((value,key) => {
                const {recno,first_name, last_name} = value;

                return (
                  <option key={key} value={recno}>{first_name} {last_name}</option>
                )
              })
            }
          </FormControl>
        </FormGroup>

        <Row>
          <Col md={4}>
            <FormGroup controlId={`individual-data-dispatch-${key}`} bsSize='sm'>
              <ControlLabel className='left-form-label'>Dispatched Time</ControlLabel>
              <TimePicker
                value={time_dispatch}
                onChange={(value) => this.onUpdateIndividual(key,'time_dispatch',value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup controlId={`individual-data-arrived-${key}`} bsSize='sm'>
              <ControlLabel className='left-form-label'>Arrival Time</ControlLabel>
              <TimePicker
                value={time_arrived}
                onChange={(value) => this.onUpdateIndividual(key,'time_arrived',value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup controlId={`individual-data-guard-${key}`} bsSize='sm'>
              <ControlLabel className="left-form-label">Guard Status</ControlLabel>
              <FormControl
                componentClass='select'
                value={guard_status}
                controlId={`individual-guard-status-${key}`}
                onChange={(e) => this.onUpdateIndividual(key,'guard_status',e.target.value)}
              >
                <option value=''>Select Guard Status</option>
                <option value='Active'>Active</option>
                <option value='Inactive'>Inactive</option>
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
      </div>
    )
  }

  renderReportingSection = () =>{
    const {data} = this.state;
    const external_agency = data.external_agency || false;

    return (
      <div className='info-section'>

        <div className='two-header-div'>
          <div className='sub-title-left'>
            <FormGroup>
              <h3 className='sub-title section-title-with-toggle'>External Agency</h3>
              <Switch
                onText='YES'
                offText='NO'
                value={external_agency}
                onChange={(el,state) => this.onUpdateData('external_agency',state)}
              />
            </FormGroup>
          </div>
          <div className='sub-title-left'>
            <h3 className='sub-title'>Reporting Personnel Details</h3>
          </div>
        </div>

        <hr className='line'/>

        <div className='left-side-content'>
          {this.renderAgencySectionContents()}
        </div>

        <div className='right-side-content'>
          {this.renderEmailSectionContents()}
        </div>
      </div>
    )
  }

  onChangeExternalAgency = (key,value) =>{
    const {data} = this.state;
    const {external_agencies} = data;

    if(value){
      external_agencies[key] = {
        time_dispatch:null,
        time_arrived:null,
        time_cleared:null
      };
    }else{
      delete external_agencies[key];
    }

    this.onUpdateData('external_agencies',external_agencies);
  }

  onUpdateExternalAgency = (key,name,value) =>{
    const {data} = this.state;
    const {external_agencies} = data;

    external_agencies[key][name] = value;
    this.onUpdateData('external_agencies',external_agencies);
  }

  renderAgency = (key,label) =>{
    const {data} = this.state;
    const {external_agencies} = data;

    const checked = external_agencies[key] ? true : false;
    const time_dispatch = checked && external_agencies[key].time_dispatch ? external_agencies[key].time_dispatch : null;
    const time_arrived = checked && external_agencies[key].time_arrived ? external_agencies[key].time_arrived : null;
    const time_cleared = checked && external_agencies[key].time_cleared ? external_agencies[key].time_cleared : null;
    const notes = checked && external_agencies[key].notes ? external_agencies[key].notes : '';

    return (
      <div>
        <FormGroup style={{textAlign:'left'}}>
          <Checkbox
            inline
            checked={checked}
            onChange={(e)=> this.onChangeExternalAgency(key,e.target.checked)}
          >
            {label}
          </Checkbox>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col md={4}>
              {this.renderAgencyTime(key, checked,'time_dispatch',time_dispatch,'Time Dispatch')}
            </Col>
            <Col md={4}>
              {this.renderAgencyTime(key, checked,'time_arrived',time_arrived,'Time Arrived')}
            </Col>
            <Col md={4}>
              {this.renderAgencyTime(key, checked,'time_cleared',time_cleared,'Time Cleared')}
            </Col>
          </Row>
        </FormGroup>
        {
          checked && (
            <FormGroup>
              <ControlLabel className='login_label'>Notes</ControlLabel>
              <FormControl
                componentClass='textarea'
                rows={4}
                value={notes}
                placeholder='Any additional notes...'
                onChange={(e) => this.onUpdateExternalAgency(key,'notes',e.target.value)}
              />
            </FormGroup>
          )
        }
      </div>
    )
  }

  renderAgencyTime = (dept, show,key,value,label) =>{
    if(show){
      return (
        <React.Fragment>
          <ControlLabel className='login_label'>{label}</ControlLabel>
          <TimePicker value={value} onChange={(e)=> {this.onUpdateExternalAgency(dept, key, e)}} dbclick={false} />
        </React.Fragment>
      )
    }

    return null;
  }

  renderAgencySectionContents = () =>{
    const {data} = this.state;
    const external_agency = data.external_agency || false;

    if(external_agency){
      return (
        <div className='section-content'>
          {this.renderAgency('fire_department','Fire Department')}
          {this.renderAgency('police_department','Police Department')}
          {this.renderAgency('ambulance_department','Ambulance')}
        </div>
      )
    }

    return null;
  }

  renderEmailSectionContents = () =>{
    const {data} = this.state;
    const facility_locations = this.props.facility_locations || [];


    const {personnel_name,personnel_phone,personnel_location_id,additional_notes} = data;

    return (
      <div className='section-content'>

        <FormGroup bsSize='sm'>
          <ControlLabel className='login_label'>Personnel Reporting This Incident</ControlLabel>
          <FormControl
            placeholder='Personel...'
            value={personnel_name}
            onChange={e => this.onUpdateData('personnel_name',e.target.value)}
          />
        </FormGroup>

        <FormGroup bsSize='sm'>
          <ControlLabel className='login_label'>Personnel Phone</ControlLabel>
          <FormControl
            placeholder='Personel phone number...'
            value={personnel_phone}
            onChange={e => this.onUpdateData('personnel_phone',e.target.value)}
          />
        </FormGroup>

        <FormGroup bsSize='sm'>
          <ControlLabel className='login_label'>Location of Personnel</ControlLabel>
          <FormControl
            componentClass='select'
            placeholder='Select location of personnel...'
            value={personnel_location_id}
            onChange={e => this.onUpdateData('personnel_location_id',e.target.value)}
          >
            {
              facility_locations.map((value,key) => {
                const {facility_location_id,location_name, is_active} = value;
                if(is_active == 1){
                  return (
                  <option key={key} value={facility_location_id}>{location_name}</option>
                  )
                }
              })
            }
          </FormControl>
        </FormGroup>

        <FormGroup bsSize='sm'>
          <ControlLabel className='login_label'>Notes</ControlLabel>
          <FormControl
              componentClass='textarea'
              rows={4}
              value={additional_notes}
              placeholder='Any additional notes...'
              onChange={(e) => this.onUpdateData('additional_notes',e.target.value)}
          />
        </FormGroup>
      </div>
    )
  }

  onUpdateFormType = (key,id) =>{
    const {forms} = this.props;
    const {data} = this.state;
    const {forms_data} = data;

    for(let x = 0; x < (forms).length; x++){
      const {recno} = forms[x];

      if(recno === id){
        forms_data[key] = forms[x];

        return this.onUpdateData('forms_data',forms_data);
      }
    }
  }

  onRemoveFormType = (key) =>{
    const {data} = this.state;
    const {forms_data} = data;

    if(forms_data[key]){
      forms_data.splice(key, 1);

      this.onUpdateData('forms_data',forms_data);
    }
  }

  onAddFormType = () =>{
    const {data} = this.state;
    const {forms_data} = data;

    (data.forms_data).push({});

    this.onUpdateData('forms_data',forms_data);
  }

  renderFormsData = (value,key) =>{
    const {forms} = this.props;
    const form_id = value && value.recno ? value.recno : '';

    return (
      <FormGroup bsSize='sm' key={key}>
        <div>
          <ControlLabel className='login_label'>Form Type</ControlLabel>

          <div className='pull-right'>
            <Glyphicon
              glyph='remove'
              style={{cursor:'pointer'}}
              onClick={() => this.onRemoveFormType(key)}
            />
          </div>
        </div>
        <FormControl
          componentClass='select'
          placeholder='Select form'
          value={form_id}
          controlId={`forms-data-${key}`}
          onChange={(e) => this.onUpdateFormType(key,e.target.value)}
        >
          {
            forms.map((value,key) => {
              const {recno,form_name} = value;

              return (
                <option value={recno} key={key}>
                  {form_name}
                </option>
              )
            })
          }
        </FormControl>
      </FormGroup>
    )
  }

  renderCreateForm = () =>{
    const {data} = this.state;
    const {forms_data} = data;
    return (
      <div className='incident-section'>
        <h3 className='sub-title sub-title-left'>Create Form</h3>

        <hr className='line' />

        <div className='left-side-content'>
          {
            forms_data.map((value,key) => {
              return this.renderFormsData(value,key);
            })
          }

          <Button className='green-btn' onClick={this.onAddFormType}>Add Document</Button>
        </div>
      </div>
    )
  }

  renderFooterSection = () =>{
    const title = this.state.editMode ? 'Save Changes' : 'Submit Dispatch';

    return (
      <div className='footer-section'>
        <Button className='red-btn' onClick={this.onResetDispatch}>Cancel</Button>
        <span> </span>
        <Button className='green-btn' onClick={this.onSubmitDispatch}>{title}</Button>
      </div>
    )
  }

  onSubmitDispatch = () =>{
    const that = this;
    const {data} = this.state;
    const {
      date_added,
      facility_id,
      call_type_id,
      facility_location_id,
      location_description,
      personnel_data,
      personnel_name,
      personnel_phone,
      personnel_location_id,
      additional_notes,
      external_agency,
      external_agencies,
      incident_narrative,
      forms_data,
      dispatch_number
    } = data;

    //if(facility_id && incident_type_id && facility_location_id && location_description){

      const other_form_data = {
        'personnel_name': personnel_name,
        'personnel_phone': personnel_phone,
        'personnel_location_id': personnel_location_id,
        'additional_notes': additional_notes,
        'external_agency': external_agency,//boolean
      };

      const dispatch_id = this.props.itemToEdit ? this.props.itemToEdit.id : '';
      const dispatch_no = this.props.itemToEdit ? this.props.itemToEdit.dispatch_number : dispatch_number;

      const param = {
        'id': dispatch_id,
        'dispatch_number': dispatch_no,
        'call_type_id': call_type_id,
        'facility_id': facility_id,
        'facility_location_id': facility_location_id,
        'location_description': location_description,
        'personnel_data': JSON.stringify( personnel_data),
        'external_agency': external_agency,
        'external_agency_data': JSON.stringify(external_agencies),
        'sub_user_id': this.state.loginResponse.data[0].recno,
        'date_added': date_added.format('YYYY-MM-DD hh:mm:ss'),
        'other_form_data': JSON.stringify(other_form_data),
        'incident_narrative': incident_narrative,
        'forms_data': JSON.stringify(forms_data)
      };

      if(this.props.itemToEdit) {

        DispatchService.sharedInstance.edit(param)
          .then(() =>{
            ToastStore.success('Dispatch successfully edited.');
            this.onReset();
            this.props.getDispatches();
          }).catch((err)=>{
            console.log('Error', err);

            ToastStore.error('Dispatch saving failed.');
          });
      } else {
        DispatchService.sharedInstance.add(param)
          .then(() =>{
            ToastStore.success('Dispatch successfully added.');

            that.onReset();
            this.props.getDispatches();
          }).catch((err)=>{
            console.log('Error', err);

            ToastStore.error('Dispatch saving failed.');
          });
      }
    /*}else{
      ToastStore.error('Required Fields: Facility, Incident Type, Location and Location Details');
    }*/
  }

  onResetDispatch = () =>{
    const {hasEdit} = this.state;

    if(hasEdit){
      this.setState({ settings_modal:true });
    }else{
      this.onReset();
    }
  }

  onReset = () =>{
    const that = this;
    const data = this.getData();

    this.getNewDispatchID();

    this.setState({
      data,
      hasEdit:false,
      settings_modal:false
    },() => {
      if(that.props.changeTab){
        that.props.changeTab();
      }

      if(that.props.onCancelTab){
        that.props.onCancelTab();
      }
    });
  }

  onCancelReset = () =>{
    this.setState({ settings_modal:false })
  }

  setSettingsModal(set) {
    this.setState({
      settings_modal: set
    })
  }

}

export default AddDispatch;
